import { format } from "date-fns";
import { get } from "lodash";

import { cleanObject } from '~/shared/lib/cleanObject';

export const optionReport = [
  { value: 1, label: "По реестру дилеров" },
  { value: 2, label: "По доступности камер" },
  { value: 3, label: "По заказ нарядам" },
  { value: 4, label: "По реестру дилеров (оффлайн/онлайн)" },
  { value: 5, label: "Отчет по сотрудникам" },
];

export const urlParams = (data) => {
  const urlParams = new URLSearchParams();
  if (data.dealers && data.dealers.length > 0) {
    data.dealers.forEach((item) => {
      urlParams.append("dealerSearch[ids][]", item.value.toString());
    });
  }

  urlParams.append("endDate", format(new Date(data.endDate), "yyyy-MM-dd"));
  urlParams.append("startDate", format(new Date(data.startDate), "yyyy-MM-dd"));
  return urlParams.toString();
};
export const LOCALIZE_DEALERS = [
  { value: "dealer", label: "Дилер" },
  // { value: "city", label: "Город" },
  // { value: "subject", label: "Субъект" },
  // { value: "FO", label: "ФО" },
  // { value: "country", label: "Страна" },
];

export const mapToOptions = (data, path) =>
  get(data, path, []).map((el) => ({ label: el, value: el }));

export const formatToServer = (data) => {
  const { startDate, endDate, localizeDealers, dynamicValues } = data;
  const values = dynamicValues?.map((item) => item.value) || [];
  const filterKey = localizeDealers?.value?.toLowerCase();

  const result = {
    startDate: startDate ? format(new Date(startDate), "yyyy-MM-dd") : "",
    endDate: endDate ? format(new Date(endDate), "yyyy-MM-dd") : "",
    dealerIds: [],
    country: "",
    fo: "",
    subject: "",
    city: "",
  };

  if (filterKey === "dealer") {
    result.dealerIds = values.map(String);
  } else if (filterKey && result.hasOwnProperty(filterKey)) {
    result[filterKey] = values.join(", ");
  }

  return cleanObject(result);
};
